export default __webpack_public_path__ + "static/media/planet10.84e64041.webp";